import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Partners.css';

const Partners = () => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const programs = [
    { name: 'МТУСИ.Бизнес', logo: '/images/clients/mtusi_buisness.png' },
    { name: 'Академия инноваторов', logo: '/images/clients/academy_innovators.svg' },
    { name: 'Акселератор ВТБ', logo: '/images/clients/vtb axelerator.webp' },
    { name: 'Yandex AI Startup Lab', logo: '/images/clients/yandex ai startup lab.svg' },
  ];

  return (
    <section className="partners" ref={ref}>
      <motion.div
        className="partners-container"
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : {}}
        transition={{ duration: 0.8 }}
      >
        <motion.div
          className="partners-content"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <p className="partners-label">Проект реализуется при поддержке</p>
          
          <div className="partners-main">
            <img 
              src="/images/clients/mtusi.png" 
              alt="МТУСИ"
              className="partners-main-logo"
            />
          </div>

          <p className="partners-programs-label">Участник программ</p>
          
          <div className="partners-programs">
            {programs.map((program, index) => (
              <motion.div
                key={index}
                className="program-item"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={inView ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
              >
                <div className="program-logo">
                  <img 
                    src={program.logo} 
                    alt={program.name}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextElementSibling.style.display = 'flex';
                    }}
                  />
                  <div className="program-placeholder" style={{display: 'none'}}>
                    <span>{program.name}</span>
                  </div>
                </div>
                <span className="program-name">{program.name}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Partners;
